// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__OoNqn","containerContent":"styles_containerContent__3t1Fn"};